import React from 'react'
import CustomTable from '../../shared/CustomTable'
import {
  progressNotesTableColumns
} from '../../constants/ProfillingConstants'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

function ProgressNotes () {
  const { t } = useTranslation()
  const { isLoading, patientDoctorNotes } = useSelector(
    state => state?.notes
  )
  return (
    <div className=''>
      <CustomTable
        isLoading={isLoading}
        columns={progressNotesTableColumns(t)}
        data={
          patientDoctorNotes?.data?.progress_notes?.map(data => ({
            ...data,
            createdAt: data?.created_at,
            updatedAt:data?.updated_at
          })) || []
        }
        rootyStyles='overflow-hidden border border-gray-200 rounded border-b-0 custom-table'
      />
    </div>
  )
}

export default ProgressNotes
